import styled from 'styled-components';

import {
	WithThemeProps,
	useCustomTheme,
	makeStandartMargins,
} from '../../styles';
import { InputStandartMargins } from '../text-field';


type RootProps = {
	disabled?: boolean;
	readonly?: boolean;
	fullWidth?: boolean;
	error: boolean;
	margin?: InputStandartMargins;
	withClearBtn?: boolean;
} & WithThemeProps;

const Root = styled.div<RootProps>`
	position: relative;
	display: inline-block;
	width: auto;
	height: auto;
	margin-top: 1px;

	${(p) => `
		& .MuiInputBase-root {
			min-width: 159px;
		}

		& .MuiInput-underline:hover:not(.Mui-disabled):before {
			border-bottom: 1px solid ${useCustomTheme(p)[0].color.blackSecondary};
		}

		& .MuiSelect-select:focus {
			background-color: transparent;
		}
		& .MuiInput-underline::after {
			border-bottom: 2px solid ${useCustomTheme(p)[0].color.accentPrimary};
		}
	`}

	${(p) => p.readonly && `
		& .MuiInputBase-root.Mui-disabled {
			color: ${useCustomTheme(p)[0].color.blackPrimary};
		}
	
		& .MuiInput-underline.Mui-disabled:before {
			border-bottom-style: solid;
		}

		& .MuiSelect-select {
			user-select: auto;
		}
	`}

	${(p) => !p.error && `
		& .MuiFormLabel-root.Mui-focused {
			color: ${useCustomTheme(p)[0].color.accentPrimary};
		}
	`}

	${(p) => p.fullWidth && `
		width: 100%;
	`}

	${(p) => p.disabled && `
		& .MuiSvgIcon-root {
			color: rgba(0, 0, 0, 0.38);
		}
	`}

	${(p) => p.withClearBtn && `
		& .MuiInputBase-inputSelect {
			padding-right: 42px;
		}
	`}

	${(p) => p.margin && `
		${makeStandartMargins(p.margin)};
	`}
`;

const IconButtonLayout = styled.div`
	position: absolute;
	top: 15px;
	right: 4px;
	transform: translateX(-50%);
`;

export {
	Root,
	IconButtonLayout,
}
